// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b9327174","453":"caf449cf","455":"23c09e3a","977":"463e50b5"}[chunkId] + ".chunk.js";
};